import React from 'react';
import { css } from 'linaria';
import {
  Accordion,
  Panel,
  Section,
  SectionSubTitle,
  Typography,
} from 'common/components';
import { analyticsUtils } from 'utils/analytics-utils';
import { CABINET_ELEMENT_BLOCK } from '../../cabinet-constants';
import {
  DEADLINE,
  DELIVERY,
  DELIVERY_TIME,
  PAYMENT,
  PROPERTIES,
  RESTRICTIONS,
  SELF_INSTALATION,
} from './cabinet-questions-constants';

export const questionAccordion = css`
  && {
    width: 877px;

    @media (--to-desktop) {
      width: 100%;
    }
  }
`;

export const CabinetQuestions = () => {
  /**
   * Обработчик нажатия на колапс панели
   */

  const handlePanelClick = (question: string, order: number) => (_: string, isOpen: boolean) => {
    if (!isOpen) {
      analyticsUtils.clickButtonEvent(
        CABINET_ELEMENT_BLOCK,
        `${question.slice(0, 100)} / ${order}`,
        'Отвечаем на вопросы'
      );
    }
  };

  return (
    <Section itemScope itemType="https://schema.org/FAQPage">
      <SectionSubTitle margin="m">Отвечаем на вопросы</SectionSubTitle>
      <Accordion className={questionAccordion}>
        <Panel name="restrictions" onClick={handlePanelClick(RESTRICTIONS, 1)} title={RESTRICTIONS}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" itemProp="text">
              Да, это возможно. Для этого используется специальная панель-подложка.
            </Typography>
          </div>
        </Panel>

        <Panel name="delivery" onClick={handlePanelClick(DELIVERY, 2)} title={DELIVERY}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" itemProp="text">
              Мы&nbsp;осуществляем доставку в&nbsp;радиусе 130&nbsp;км от&nbsp;Москвы и&nbsp;Санкт-Петербурга.
            </Typography>
          </div>
        </Panel>

        <Panel name="deadline" onClick={handlePanelClick(DEADLINE, 3)} title={DEADLINE}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" itemProp="text">
              Доставка и&nbsp;сборка выполняются в&nbsp;разные дни, чтобы всё прошло максимально качественно.
            </Typography>
          </div>
        </Panel>

        <Panel name="properties" onClick={handlePanelClick(PROPERTIES, 4)} title={PROPERTIES}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" itemProp="text">
              Наши панели имеют толщину 16&nbsp;мм&nbsp;&mdash; это стандарт, обеспечивающий прочность и&nbsp;долговечность.
            </Typography>
          </div>
        </Panel>

        <Panel name="selfInstalation" onClick={handlePanelClick(SELF_INSTALATION, 5)} title={SELF_INSTALATION}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" itemProp="text">
              Технически это возможно, но&nbsp;только при наличии необходимого инструмента и&nbsp;навыков работы с&nbsp;пилой, перфоратором и&nbsp;лобзиком. Мы&nbsp;рекомендуем доверить установку нашим специалистам, чтобы избежать возможных сложностей.
            </Typography>
          </div>
        </Panel>

        <Panel name="deliveryTime" onClick={handlePanelClick(DELIVERY_TIME, 6)} title={DELIVERY_TIME}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" itemProp="text">
              Сроки зависят от&nbsp;сложности изделия и&nbsp;выбранных материалов. В&nbsp;среднем&nbsp;&mdash; от&nbsp;21&nbsp;дня после оплаты. Точный срок сообщим сразу после согласования заказа.
            </Typography>
          </div>
        </Panel>

        <Panel name="payment" onClick={handlePanelClick(PAYMENT, 7)} title={PAYMENT}>
          <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
            <Typography variant="s" size="body_long" itemProp="text">
              Оплатить можно удобным для вас способом: картой по&nbsp;ссылке, через СБП, наличными или картой на&nbsp;кассе. У&nbsp;нас также доступна рассрочка&nbsp;&mdash; Яндекс Сплит и&nbsp;банки-партнёры.
            </Typography>
          </div>
        </Panel>
      </Accordion>
    </Section>
  );
};